import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { StylesConfig, GroupBase } from 'react-select';
import { MultiSelectOption } from './MultiSelect.types';

export const MultiSelectLabel = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: -8,
  left: 12,
  backgroundColor: '#fff',
  paddingInline: 4,
  fontSize: '12px',
  fontWeight: 500,
  borderRadius: '2px',
  color: theme.palette.primary.main,
  zIndex: 2,
  lineHeight: 1,
}));

export const CollapsedTagCount = styled('div')(() => ({
  backgroundColor: '#f0f0f0',
  borderRadius: '12px',
  padding: '2px 6px',
  marginLeft: 4,
  fontSize: 12,
  color: '#333',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  height: '24px',
}));

export const getMultiSelectCustomStyles = (
  width: number
): StylesConfig<MultiSelectOption, true, GroupBase<MultiSelectOption>> => ({
  container: (base) => ({
    ...base,
    width,
  }),
  control: (base, state) => ({
    ...base,
    fontSize: '13px',
    minHeight: '38px',
    backgroundColor: '#fff',
    borderRadius: 4,
    borderColor: state.isFocused ? '#2684FF' : '#ccc',
    boxShadow: 'none',
    outline: 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#2684FF' : '#999',
    },
    transition: 'border-color 0.2s',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: 'transform 0.2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
  }),
  menu: (base) => ({
    ...base,
    width,
    marginTop: 4,
    zIndex: 1300,
  }),
  option: (base, state) => ({
    ...base,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 14,
    transformOrigin: 'left',
    fontWeight: 400,
    color: state.isFocused ? '#2684FF' : state.isSelected ? '#000000' : '#333',
    backgroundColor: state.isSelected ? '#f0f0f0' : 'white',
    cursor: 'pointer',
    transition: 'background-color 300ms ease',
    '&:active': {
      backgroundColor: '#e4ebf1',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    flexWrap: 'nowrap',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#f0f0f0',
    borderRadius: '12px',
    padding: '2px 6px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    backgroundColor: '#f0f0f0',
    fontSize: '12px',
    lineHeight: '1.2',
    maxWidth: '200px',
  }),
  groupHeading: (base) => ({
    ...base,
    fontSize: '11px',
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    backgroundColor: '#9e9e9e',
    color: '#fff',
    borderRadius: '50%',
    width: 16,
    height: 16,
    marginLeft: 6,
    marginTop: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '& svg': {
      width: 14,
      height: 14,
      transform: 'scale(1.8)',
      transformOrigin: 'center',
    },
    ':hover': {
      backgroundColor: '#787878',
      color: '#fff',
    },
  }),
});
